import BooleanTag from '@/components/app/BooleanTag';
import CreateBtn from '@/components/app/CreateBtn';
import ZTable, { IColumnType, IFilterItem, ITableRef } from '@/components/ZTable';
import { formatDate } from '@/config';
import { MasterServiceType } from '@/constants';
import { clearAllServiceConfigurationsCache } from '@/hooks/data/masterDataHook';
import MainContent from '@/layouts/MainContent';
import { Tag, Tooltip } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import CreateUpdateModal from './CreateUpdateModal';
import { CompanyModel } from '@/__generated';

const PAGE_TITLE = 'servicePages_Title';

const filters: Array<IFilterItem> = [{ type: 'TEXT', name: 'searchText', mdSize: 8, xlSize: 8, xxlSize: 8, label: 'servicePages_SearchText' }];
const columns: IColumnType<CompanyModel>[] = [
  {
    title: 'servicePages_ServiceName',
    dataIndex: 'serviceName',
    sorter: true,
    ellipsis: true,
    width: 200,
  },
  {
    title: 'base.Country',
    dataIndex: 'countryName',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'servicePages_ActivationDate',
    dataIndex: 'activationDate',
    ellipsis: true,
    render: v => formatDate(v),
    width: 120,
  },
  {
    title: 'base.Enabled',
    dataIndex: 'isEnabled',
    render: v => <BooleanTag value={v} />,
    ellipsis: true,
    align: 'center',
    width: 100,
  },
  {
    title: 'servicePages_AvailableApps',
    dataIndex: 'availableApps',
    render: v => (
      <span>
        {v.map(x => (
          <Tag key={x}>{x}</Tag>
        ))}
      </span>
    ),
    ellipsis: true,
    width: 250,
  },
  {
    title: 'servicePages_MasterServiceType',
    dataIndex: 'masterServiceType',
    render: v => MasterServiceType.__getValue(v),
    ellipsis: true,
    width: 150,
  },
  {
    title: 'base.Description',
    dataIndex: 'description',
    width: 150,
    render: v => (v ? <Tooltip title={v}>{v}</Tooltip> : ''),
  },
];
export default function ServicesPage() {
  const { t } = useTranslation();
  const zTb = React.useRef<ITableRef>();
  const [formVisible, setFormVisible] = React.useState(false);
  const [serviceId, setServiceId] = React.useState<string>();
  const clearCache = () => {
    clearAllServiceConfigurationsCache();
  };
  const onEdit = (id: string) => {
    setServiceId(id);
    setFormVisible(true);
  };
  return (
    <MainContent
      title={t(PAGE_TITLE)}
      extraBtns={[
        <CreateBtn
          onClick={() => {
            setFormVisible(true);
          }}
        />,
      ]}
    >
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <ZTable
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          url="/commons/services/get-services"
          bordered
          order_by="createdOn"
          order_by_asc={true}
          allowEdit={true}
          allowDelete={true}
          onEdit={record => {
            onEdit(record.id);
          }}
          delete_url="/commons/services/delete"
          filters={filters}
          searchBtnAlignLeft
          onDeleteCompleted={clearCache}
        />
      </div>
      {formVisible ? (
        <CreateUpdateModal
          serviceId={serviceId}
          onClose={reload => {
            setFormVisible(false);
            setServiceId(undefined);
            if (reload) {
              zTb.current?.reload();
            }
          }}
        />
      ) : null}
    </MainContent>
  );
}
